import { TableColumnType } from 'antd'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../../../models/datetime'
import { Dimen } from '../../../../models/dimen'
import { NoFormulas } from '../../../../models/noformula'
import { getRecipeCategoryName } from '../../../../models/recipe'
import { getRegistrationStateName } from '../../../../models/registration'
import { getGenderName } from '../../../../models/user'
import { getAge } from '../../../../utils/StringUtils'

export const recipeColumn = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "结算险种",
    //   dataIndex: "registrationCategory",
    //   align: "center",
    //   render: function registrationCategory(registrationCategory: number) {
    //     return registrationCategory === 0 ? "自费" : "医保";
    //   },
    // },

    {
      title: '姓名',
      dataIndex: 'patientName',
      align: 'center',
      width: Dimen.Name,
      key: 'patientName',
    },
    {
      title: '病历号',
      key: 'patientId',
      width: Dimen.Sex,
      align: 'center',
      dataIndex: 'patientId',
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
      width: Dimen.Sex,
      render: (_: string, u: any) => getGenderName(u.patientSex),
    },
    {
      title: '年龄',
      dataIndex: 'patientAge',
      align: 'center',
      width: Dimen.Age,
      key: 'patientAge',
      render: (_, r) => getAge(r?.patientAge, r?.patientMonth),
    },
    {
      title: '疾病名称',
      dataIndex: 'disease',
      align: 'center',
      key: 'disease',
    },
    {
      title: '就诊科室',
      dataIndex: 'treatmentDepartmentName',
      align: 'center',
      width: Dimen.Department,
      key: 'treatmentDepartmentName',
    },
    {
      title: '就诊医生',
      dataIndex: 'treatmentDoctorName',
      width: Dimen.Doctor,
      align: 'center',
    },
    {
      title: '就诊时间',
      dataIndex: 'registrationTime',
      align: 'center',
      width: Dimen.Time,
      key: 'registrationTime',
      render: (_, r) => {
        return moment(r.registrationTime).format(DateTimeFormatSimple)
      },
    },
    {
      title: '就诊状态',
      dataIndex: 'registrationState',
      align: 'center',
      width: Dimen.State,
      key: 'registrationState',
      render: (_, r) => getRegistrationStateName(r.registrationState),
    },
    {
      title: '处方名称',
      dataIndex: 'category',
      align: 'center',
      width: Dimen.Category,
      key: 'category',
      render: (_: string, u: NoFormulas) => getRecipeCategoryName(u.category),
    },
    {
      title: '药品用法',
      dataIndex: 'normalUsemethod',
      width: Dimen.Usemethod,
      key: 'normalUsemethod',
      align: 'center',
    },
  ]
}
